import { render, staticRenderFns } from "./SdsFileUpload.vue?vue&type=template&id=5551fd7a&scoped=true"
import script from "./SdsFileUpload.vue?vue&type=script&setup=true&lang=ts"
export * from "./SdsFileUpload.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SdsFileUpload.vue?vue&type=style&index=0&id=5551fd7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5551fd7a",
  null
  
)

export default component.exports